
const sigortaDurumOptions = [
    {
        value: "Boş Olanlar",
        text: "Boş Olanlar"
    },
    {
        value: "Yapıldı",
        text: "Yapıldı"
    },
    {
        value: "Yapılmadı",
        text: "Yapılmadı"
    },
    {
        value: "Tümü",
        text: "Tümü"
    }
]

export {sigortaDurumOptions}